module.exports = __webpack_public_path__ + "img/arthur-conan-banner.200ed301.png";